import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { variables } from '../../assets/styles/variables';

const TextButtonStyles = styled.button`
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  width: auto;
  height: auto;
  font-size: ${(props) => () => variables.typography.p[props.variant].fontSize};
  line-height: ${(props) => () =>
    variables.typography.p[props.variant].lineHeight};
  text-decoration: underline;
  font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 400)};
  ${({ emailVariant }) =>
    emailVariant &&
    `margin-left: 3px;
  }`}
  ${({ emailMargin }) =>
    emailMargin &&
    `margin-left: 3px;
  }`}

  ${({ emailVariant }) =>
    emailVariant &&
    `@media only screen and (max-width: 500px) {
    display: flex;
    justify-content: flex-end;
  }`}
`;

const TextButton = ({
  onClick,
  children,
  variant = 'regular',
  fontWeight,
  emailVariant,
  emailMargin,
}) => (
  <TextButtonStyles
    fontWeight={fontWeight}
    variant={variant}
    onClick={onClick}
    emailVariant={emailVariant}
    emailMargin={emailMargin}
  >
    {children}
  </TextButtonStyles>
);

TextButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  variant: PropTypes.string,
  fontWeight: PropTypes.number,
  emailVariant: PropTypes.bool,
  emailMargin: PropTypes.bool,
};

export default TextButton;
